import {Sizes} from "@/constants/size";
import CreaturePanel from "@/scenes.ui/creature-panel";
import CU from "./c-u";
import {MultiBattlePos} from "@/utils/battle-utils";
import {TeamTag} from "@/store/battle/types";
import Group = Phaser.GameObjects.Group;
import Scene = Phaser.Scene;
import GameObject = Phaser.GameObjects.GameObject;
import {Point} from "@/model/point";

export class GridUtils {

    public static align(objs: GameObject[], t: TeamTag, p: MultiBattlePos) {
        if (t === TeamTag.TM1) {
            switch (objs.length) {
                case 1:
                    this.setDot(objs, p.t1P1, 0);
                    break;
                case 2:
                    this.setDot(objs, p.t1P2, 0);
                    this.setDot(objs, p.t1P2, 1);
                    break;
                case 3:
                    this.setDot(objs, p.t1P3, 0);
                    this.setDot(objs, p.t1P3, 1);
                    this.setDot(objs, p.t1P3, 2);
                    break;
                case 4:
                    this.setDot(objs, p.t1P4, 0);
                    this.setDot(objs, p.t1P4, 1);
                    this.setDot(objs, p.t1P4, 2);
                    this.setDot(objs, p.t1P4, 3);
                    break;
                case 5:
                    this.setDot(objs, p.t1P5, 0);
                    this.setDot(objs, p.t1P5, 1);
                    this.setDot(objs, p.t1P5, 2);
                    this.setDot(objs, p.t1P5, 3);
                    this.setDot(objs, p.t1P5, 4);
                    break;
                case 6:
                    this.setDot(objs, p.t1P6, 0);
                    this.setDot(objs, p.t1P6, 1);
                    this.setDot(objs, p.t1P6, 2);
                    this.setDot(objs, p.t1P6, 3);
                    this.setDot(objs, p.t1P6, 4);
                    this.setDot(objs, p.t1P6, 5);
                    break;
            }
        } else if (t === TeamTag.TM2) {
            switch (objs.length) {
                case 1:
                    this.setDot(objs, p.t2P1, 0);
                    break;
                case 2:
                    this.setDot(objs, p.t2P2, 0);
                    this.setDot(objs, p.t2P2, 1);
                    break;
                case 3:
                    this.setDot(objs, p.t2P3, 0);
                    this.setDot(objs, p.t2P3, 1);
                    this.setDot(objs, p.t2P3, 2);
                    break;
                case 4:
                    this.setDot(objs, p.t2P4, 0);
                    this.setDot(objs, p.t2P4, 1);
                    this.setDot(objs, p.t2P4, 2);
                    this.setDot(objs, p.t2P4, 3);
                    break;
                case 5:
                    this.setDot(objs, p.t2P5, 0);
                    this.setDot(objs, p.t2P5, 1);
                    this.setDot(objs, p.t2P5, 2);
                    this.setDot(objs, p.t2P5, 3);
                    this.setDot(objs, p.t2P5, 4);
                    break;
                case 6:
                    this.setDot(objs, p.t2P6, 0);
                    this.setDot(objs, p.t2P6, 1);
                    this.setDot(objs, p.t2P6, 2);
                    this.setDot(objs, p.t2P6, 3);
                    this.setDot(objs, p.t2P6, 4);
                    this.setDot(objs, p.t2P6, 5);
                    break;
            }
        } else if (t === TeamTag.TM3) {
            switch (objs.length) {
                case 1:
                    this.setDot(objs, p.t2P2, 0);
                    break;
            }
        }
    }

    private static setDot(objs: GameObject[], points: Point[], ind: number) {
        let c: CreaturePanel = objs[ind] as CreaturePanel;
        c.x = points[ind].x * CU.S;
        c.y = CU.CANVAS_HEIGHT - points[ind].y * CU.S;
    }

    public static gridAlign(group: Group, y: number, scene: Scene, isPlayerSquad: boolean, posType: PosType): void {
        this.doGridAlign(group.getChildren(), y, scene, isPlayerSquad, posType);
    }

    public static doGridAlign(children: GameObject[], y: number, scene: Scene, isPlayerSquad: boolean, posType: PosType): void {

        let firstGroup: GameObject[] = children.slice(0, 6);
        let secondGroup: GameObject[] = children.slice(6, children.length);

        // @ts-ignore
        this.setAlign(firstGroup, this.calculatePosX(firstGroup.length, scene.canvas.width, firstGroup.length),  secondGroup.length > 0 ? y - 75 * CU.S : y,
            this.getCellWidth(firstGroup.length), Sizes.CELL_HEIGHT, posType);

        if (secondGroup.length > 0) {
            // @ts-ignore
            this.setAlign(secondGroup, this.calculatePosX(secondGroup.length, scene.canvas.width, secondGroup.length), this.calculatePosY(y, isPlayerSquad),
                this.getCellWidth(secondGroup.length), Sizes.CELL_HEIGHT, posType);
        }

    }

    private static setAlign(group: GameObject[], x: number, y: number, cellWidth: number, cellHeight: number, posType: PosType) {
        console.log('pt = ' + posType + '; gr.size = ' + group.length);
        switch (posType) {
            case PosType.CURVE_UP:
            case PosType.CURVE_DOWN:
                let canwWidth = CU.CANVAS_WIDTH;
                let width = canwWidth - 2 * x;
                let center = canwWidth / 2;
                let ellipseRatio = 3;
                let yy = Math.sqrt((width * width) / ellipseRatio) - 25 * CU.S;
                let sign = posType === PosType.CURVE_UP ? 1 : -1;
                let xx = group.length > 5 ? x + 13 * CU.S : x;
                for (let i = 0; i < group.length; ++i) {
                    let c: CreaturePanel = group[i] as CreaturePanel;
                    c.x = xx;
                    c.y = y + (sign * yy - sign * Math.sqrt(((width * width - (xx - center) * (xx - center)) / ellipseRatio)));
                    xx += cellWidth;
                }
                break;
            case PosType.LINE:
                Phaser.Actions.GridAlign(group, {
                    cellWidth: cellWidth,
                    cellHeight: cellHeight,
                    x: x - cellWidth / 2 / CU.S,
                    y: y - cellHeight / 2,
                });
                break;
        }
    }

    private static calculatePosX(elementsQuantity: number, canvasWidth: number, elementsCount: number): number {
        let res = (canvasWidth - (elementsQuantity - 1) * this.getCellWidth(elementsQuantity)) / 2;
        if (elementsCount > 5) {
            res -= 13 * CU.S;
        }
        return res;
    }

    private static calculatePosY(y: number, isPlayerSquad: boolean): number {
        return isPlayerSquad ?  y + 85 * CU.S : y - 150 * CU.S;
    }

    private static getCellWidth(elementsCount: number) {
        if (elementsCount < 5) {
            return Sizes.CELL_WIDTH * CU.S;
        } else if (elementsCount === 5) {
            return (Sizes.CELL_WIDTH - 20) * CU.S;
        } else {
            return (Sizes.CELL_WIDTH - 27) * CU.S;
        }
    }
}

export enum PosType { LINE, CURVE_UP, CURVE_DOWN }
